function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import cn from 'classnames';
import React, { useContext, useState } from 'react';
import { Navbar as BSNavbar } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import CartButton from '../../../../../components/button/CartButton';
import Icon from '../../../../../components/icon/Icon';
import Link from '../../../../../components/Link/Link';
import { MapViewContext } from '../../../../../components/mapView/mapViewContext';
import useMembershipButton from '../../../../../hooks/useMembershipButton';
import { useRedirect } from '../../../../../hooks/useRedirect';
import useShareLinkParams, { useNew3dBookmark, useShareLinkMetadata } from '../../../../../hooks/useShareLinkParams';
import { toggleRightMenuVisibility, toggleSidenavVisibility } from '../../../../../redux/actions/layout';
import { profileSelectors } from '../../../../../redux/selectors/profile';
import routes from '../../../../../routes/constants';
import text from '../../../../../text';
import { jobHasPointCloud } from '../../../../../utilities/job';
import { getProjectLatestJob, isDemoProject } from '../../../../../utilities/project';
import { isRouteIncluded } from '../../../../../utilities/routes';
import { isImpersonating } from '../../../../../utilities/storage';
import MarketingNav from './MarketingNav';
import ShareLink from './ShareLink';
import Titlebar from './Titlebar';
import UserNav from './UserNav';
var ROUTES_MARKETING_NAV_ENABLED = [
    routes.password.reset,
    routes.password.create,
    routes.password.forgot,
    routes.logout,
    routes.login,
    routes.signUp
];
var ROUTES_VIEW_MODE_BUTTON_VISIBLE = [
    routes.order.root,
    routes.fileManager.root,
    routes.view3D.root
];
var isMarketingNavEnabled = isRouteIncluded(ROUTES_MARKETING_NAV_ENABLED);
var isViewModeButtonVisible = isRouteIncluded(ROUTES_VIEW_MODE_BUTTON_VISIBLE);
var is2DMap = isRouteIncluded([
    routes.order.root
]);
var is3DViewer = isRouteIncluded([
    routes.view3D.root
]);
var isFileManager = isRouteIncluded([
    routes.fileManager.root
]);
var isCartButtonVisible = function(pathname) {
    return isRouteIncluded([
        routes.view3D.root,
        routes.order.root,
        routes.fileManager.viewProject()
    ])(pathname);
};
var Navbar = function() {
    var _project_currentProject, _project_currentProject1, _project_currentProject2;
    var location = useLocation();
    // const history = useHistory();
    var redirect = useRedirect();
    var _useSelector = useSelector(function(state) {
        return state;
    }), layout = _useSelector.layout, project = _useSelector.project;
    var dispatch = useDispatch();
    var _useState = _sliced_to_array(useState(false), 2), isMenuOpen = _useState[0], setIsMenuOpen = _useState[1];
    var isMarketingNavVisible = isMarketingNavEnabled(location.pathname);
    var actions = useContext(MapViewContext).actions;
    var _useContext = useContext(MapViewContext), numCartItems = _useContext.state.numCartItems;
    var isAdmin = useSelector(profileSelectors.getIsAdmin);
    var handleMembershipClick = useMembershipButton().handleMembershipClick;
    var latestJob = ((_project_currentProject = project.currentProject) === null || _project_currentProject === void 0 ? void 0 : _project_currentProject.id) && getProjectLatestJob(project.currentProject);
    var is3dViewerAccessibleToUser = useSelector(profileSelectors.get3dViewerEnabled);
    var hasPointCloud = jobHasPointCloud(latestJob);
    var isDemoProj = isDemoProject(project.currentProject);
    var is3dViewerLocked = hasPointCloud && !is3dViewerAccessibleToUser && !isDemoProj;
    var is3dViewerDisabled = !hasPointCloud || !is3dViewerAccessibleToUser && !isDemoProj;
    var _3dViewerRoute = isAdmin ? "".concat(routes.view3DExternal.project((_project_currentProject1 = project.currentProject) === null || _project_currentProject1 === void 0 ? void 0 : _project_currentProject1.id), "?admin=true") : "".concat(routes.view3DExternal.project((_project_currentProject2 = project.currentProject) === null || _project_currentProject2 === void 0 ? void 0 : _project_currentProject2.id));
    var _2dMapRoute = (latestJob === null || latestJob === void 0 ? void 0 : latestJob.id) ? latestJob.mp_enabled ? routes.mp.job(latestJob.id) : routes.order.job(latestJob.id) : routes.order.root;
    var viewModes = [
        {
            icon: '2d-map',
            toggleIcon: '2d-map',
            text: text('twoD'),
            onClick: function() {
                return !is2DMap(location.pathname) && redirect.push((latestJob === null || latestJob === void 0 ? void 0 : latestJob.id) ? latestJob.lga ? routes.order.root : _2dMapRoute : routes.order.root);
            },
            tooltipProps: {
                text: text('map2D'),
                placement: 'bottom'
            },
            enabled: is2DMap(location.pathname)
        },
        {
            icon: 'file',
            toggleIcon: 'file',
            text: text('file'),
            onClick: function() {
                var _project_currentProject;
                return !isFileManager(location.pathname) && redirect.push(((_project_currentProject = project.currentProject) === null || _project_currentProject === void 0 ? void 0 : _project_currentProject.id) ? routes.fileManager.viewProject(project.currentProject.id) : routes.fileManager.root);
            },
            tooltipProps: {
                text: text('fileManager'),
                placement: 'bottom'
            },
            enabled: isFileManager(location.pathname)
        },
        {
            icon: '3D',
            toggleIcon: '3D',
            disabled: is3dViewerDisabled && !is3dViewerLocked,
            text: text('threeD'),
            onClick: function() {
                return is3dViewerLocked ? handleMembershipClick({
                    redirectTo: {
                        path: _3dViewerRoute,
                        label: text('navigateToRoute', {
                            navigation: 'Continue',
                            routeName: text('viewer3D')
                        })
                    }
                }) : !is3DViewer(location.pathname) && redirect.push(routes.view3DExternal.project(project.currentProject.id));
            },
            tooltipProps: {
                text: text('viewer3D'),
                placement: 'bottom'
            },
            enabled: is3DViewer(location.pathname),
            locked: is3dViewerLocked
        }
    ];
    var _useShareLinkParams = useShareLinkParams(), isShareLinkAvailable = _useShareLinkParams.isAvailable, shareLinkParams = _object_without_properties(_useShareLinkParams, [
        "isAvailable"
    ]);
    var metadata = useShareLinkMetadata();
    var new3dBookmark = useNew3dBookmark();
    return /*#__PURE__*/ React.createElement(BSNavbar, {
        expanded: isMenuOpen,
        className: cn('Navbar', {
            impersonate: isImpersonating()
        }),
        variant: isMarketingNavVisible ? 'light' : 'dark',
        expand: "lg"
    }, isMarketingNavVisible ? /*#__PURE__*/ React.createElement(BSNavbar.Toggle, {
        id: "menuButton",
        "aria-controls": "basic-navbar-nav",
        className: "Navbar-Toggle",
        onClick: function() {
            return setIsMenuOpen(!isMenuOpen);
        }
    }, isMenuOpen ? /*#__PURE__*/ React.createElement(Icon, {
        icon: "close-box"
    }) : /*#__PURE__*/ React.createElement(Icon, {
        icon: "menu"
    }), text('menu')) : /*#__PURE__*/ React.createElement(BSNavbar.Toggle, {
        id: "menuButton",
        "aria-controls": "basic-navbar-nav",
        className: "Navbar-Toggle",
        onClick: function(evt) {
            dispatch(toggleSidenavVisibility(!layout.sideNav.isVisible));
            evt.stopPropagation();
        }
    }, layout.sideNav.isVisible ? /*#__PURE__*/ React.createElement(Icon, {
        icon: "close-box"
    }) : /*#__PURE__*/ React.createElement(Icon, {
        icon: "menu"
    }), text('menu')), /*#__PURE__*/ React.createElement(BSNavbar.Brand, {
        className: "Navbar-Brand"
    }, isMarketingNavVisible ? /*#__PURE__*/ React.createElement("a", {
        href: process.env.LARKI_MARKETING_URL
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "larki-logo"
    })) : /*#__PURE__*/ React.createElement(Link, {
        to: routes.home
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "larki-logo"
    }))), /*#__PURE__*/ React.createElement(Titlebar, null), !isMarketingNavVisible && /*#__PURE__*/ React.createElement("div", {
        className: cn('ViewModeButtonGroup', {
            visible: isViewModeButtonVisible(location.pathname)
        })
    }, viewModes.map(function(viewMode, index) {
        return /*#__PURE__*/ React.createElement(BSNavbar.Toggle, {
            key: index,
            "aria-controls": "basic-navbar-nav",
            disabled: viewMode.disabled,
            className: cn('Navbar-Toggle position-relative', {
                enabled: viewMode.enabled,
                disabled: viewMode.locked
            }),
            onClick: viewMode.onClick
        }, /*#__PURE__*/ React.createElement(Icon, {
            icon: viewMode.toggleIcon
        }), viewMode.locked ? /*#__PURE__*/ React.createElement("div", {
            className: "lock-badge-container transparent-bg",
            style: {
                top: '-4px'
            }
        }, /*#__PURE__*/ React.createElement(Icon, {
            icon: "lock",
            style: {
                height: '20px',
                width: '20px'
            }
        })) : null, viewMode.text);
    })), isMarketingNavVisible && /*#__PURE__*/ React.createElement(MarketingNav, null), isShareLinkAvailable ? // This is to show the share link button in File manager page
    /*#__PURE__*/ React.createElement("div", {
        className: "share-link__container"
    }, /*#__PURE__*/ React.createElement(ShareLink, _object_spread_props(_object_spread({}, shareLinkParams), {
        metadata: metadata,
        new3dBookmark: new3dBookmark
    }))) : null, !isMarketingNavVisible && /*#__PURE__*/ React.createElement(UserNav, {
        className: cn({
            viewModeVisible: isViewModeButtonVisible(location.pathname)
        })
    }), isCartButtonVisible(location.pathname) && // <BSNavbar.Toggle
    //   id='cartButton'
    //   aria-controls='basic-navbar-nav'
    //   className={cn('Navbar-Toggle')}
    //   onClick={() =>
    //     dispatch(toggleRightMenuVisibility(!layout.rightMenu.isVisible))
    //   }
    // >
    //   {layout.rightMenu.isVisible ? (
    //     <Icon icon='close-box' />
    //   ) : (
    //     <Icon icon='shopping-cart' />
    //   )}
    //   {text('cart')}
    // </BSNavbar.Toggle>
    /*#__PURE__*/ React.createElement(CartButton, {
        as: BSNavbar.Toggle,
        className: "Navbar-Toggle",
        onClick: function() {
            actions.setShowProductModal(false);
            dispatch(toggleRightMenuVisibility(!layout.rightMenu.isVisible));
        },
        open: layout.rightMenu.isVisible,
        count: numCartItems
    }));
};
export default Navbar;
